import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { fetchMenus } from '../../features/navbar/NavbarSlice';
import { Link } from 'react-router-dom';
import * as Icon from 'react-feather';
function Home() {
    const [menuData, setMenuData] = useState()
    const dispatch = useDispatch()
    const token = localStorage.getItem('token')
    const menus = useSelector(state => state.navbar.menus)
    const message = useSelector(state => state.navbar.message)
    const { username, mobile, email } = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : []

    useEffect(() => {

        dispatch(fetchMenus(token))

    }, [])
    return (
        // <div className='row'>
        // {
        // menus.map((menu) => (
        //     menu.submenus.map((row) => ( 
        //         <div className="col-3">
        //             <Link 
        //                 to={'/dashboard'+row.path} 
        //                 className="btn p-3 my-2 text-center rounded d-flex flex-column justify-content-center align-items-center fs-6 text-black text-opacity-75 px-3 py-3 rounded" 
        //                 key={row.id}>
        //                 <i className={'fa-regular fa-calendar fa-fw fa-stack fa-lg'}></i>
        //                 <strong>{row.title}</strong>
        //             </Link>
        //         </div>
        //     ))
        // ))
        <>
            <div className='row justify-content-center align-items-center'>
                <div className='col-12 col-md-3 mb-2'>
                    <div className="rahpardaznet-card-item">
                        <Icon.Layers />
                        <Link to={'/dashboard/documents'}>
                            <span className='mb-3'>مدیریت سند</span>

                        </Link>
                    </div>
                </div>
                <div className='col-12 col-md-3 mb-2'>
                    <div className="rahpardaznet-card-item">
                        <Icon.FilePlus/>
                        <Link to={'/dashboard/document/create'}>
                            <span className='mb-3'>ثبت سند</span>
                        </Link>
                    </div>
                </div>
                <div className='col-12 col-md-3 mb-2'>
                    <div className="rahpardaznet-card-item">
                    <Icon.Repeat/>
                        <Link to={'/dashboard/document/transfer'}>
                            <span className='mb-3'>انتقال مالکیت</span>
                        </Link>
                    </div>
                </div>
                <div className='col-12 col-md-3 mb-2'>
                    <div className="rahpardaznet-card-item">
                        <Icon.Clock/>
                        <Link to={'/dashboard/document/request/create'}>
                            <span className='mb-3'>نوبت دهی</span>
                        </Link>
                    </div>
                </div>
            </div>

        </>

        //     }

        //    </div>
    )
}

export default Home;